import React from "react";
import { Row, Col, Container } from "react-bootstrap";

import StoryblokImage from "../../internal/storyblokImage/StoryblokImage";
import {
  resolveRichTextWithComponents,
} from "../../../utils/richText";
import Buttons from "../../internal/buttons/Buttons";
import WidgetWrapper from "../../internal/widgetWrapper/WidgetWrapper";
import styled from "styled-components";
import ModalHelper from "../../../utils/modalHelper";

import "./TwoColumnCard.scss";

const ContentContainer = styled.div`
  @media screen and (min-width: 1200px) {
    max-width: ${props => props.contentWidth};
    margin-left: auto;
    margin-right: auto;
  }
`;

const TwoColumnCard = (blok) => {
  const {
    cta_link,
    cta_text,
    header_text,
    is_modal,
    cta_color,
    inline_image,
    modal_id,
    content_width,
    modal
  } = blok.blok;

  const buttonProps = {
    text: cta_text,
    url: cta_link,
    textColor: cta_color,
    isModal: is_modal,
    modalId: modal_id,
    modal: modal
  };

  let contentWidth = content_width ? content_width + "px" : "auto";

  return (
    <WidgetWrapper blok={blok.blok}>
      <ContentContainer contentWidth={contentWidth}>
        <Container className="two-column-card-container">
          <Row>
            <Col className="justify-content-center header-text">
              {resolveRichTextWithComponents(header_text)}
            </Col>
          </Row>
          {inline_image &&
          inline_image.filename !== "" &&
          inline_image.filename !== null ? (
            <Row>
              <Col className="justify-content-center inline-image">
                <StoryblokImage sbImageData={inline_image} />
              </Col>
            </Row>
          ) : null}
          {cta_text && cta_text !== "" && cta_text != null ? (
            <Row>
              <Col className="justify-content-center btn-wrapper">
                <div className="general-button-wrapper">
                  {modal ? <ModalHelper buttonProps={buttonProps} /> : <Buttons buttonProps={buttonProps} />}
                </div>
              </Col>
            </Row>
          ) : null}
        </Container>
      </ContentContainer>
    </WidgetWrapper>
  );
};

export default TwoColumnCard;
